import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { CreateAlertModal } from 'src/modules/features/setting/modals/app-security-modals/create-alert-modal/create-alert-modal.component';
import { EditFileSizeModal } from 'src/modules/features/setting/modals/app-security-modals/edit-file-size-modal/edit-file-size-modal.component';
import { FileUploadLimitModal } from 'src/modules/features/setting/modals/app-security-modals/file-upload-limit-modal/file-upload-limit-modal.component';
import { SecurityConfirmationModal } from 'src/modules/features/setting/modals/app-security-modals/security-confirmation-modal/security-confirmation-modal.component';
import { ApplicationSecurityService } from 'src/modules/features/setting/components/application-security/services/application-security.service';

@Component({
  selector: 'app-file-upload-settings',
  templateUrl: './file-upload-settings.component.html',
  styleUrls: ['./file-upload-settings.component.scss'],
})
export class FileUploadSettingsComponent implements OnInit {
  filter: AppFilter = new AppFilter({ sidx: 'dateModified' });
  pending: boolean;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  files: Array<any> = [];
  error: any;
  searchFilter = {
    groupOp: 'AND',
    rules: [],
  };
  organizationId: string;
  success: any;
  constructor(
    private appSecuritySvc: ApplicationSecurityService,
    private modalService: SuiModalService
  ) {}

  ngOnInit(): void {
    this.getPage(1);
  }

  getPage(page: number) {
    this.filter.page = page;
    this.pending = true;
    this.appSecuritySvc
      .getAllFileManagementSettings({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.currentPage = page;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.files = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  viewConcurrentUploadLimit(file) {
    this.modalService
      .open(new FileUploadLimitModal('Concurrent Upload Limits', file))
      .onApprove(() => {})
      .onDeny(() => {});
  }

  blacklistIpAddress(file) {}

  editConcurrentUploadLimit(file) {
    let title: string;

    switch (file.fileSettingsId) {
      case 'file_size_configuration':
        title = 'Maximum File Size';
        break;
      case 'allowed_file_types':
        title = 'Allowed File Types';
        break;
      case 'file_upload_response':
        title = 'File Upload Feedback';
        break;
      default:
        title = 'Edit Concurrent Upload Limits';
        break;
    }
    this.modalService
      .open(new EditFileSizeModal(title, file))
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }

  createLogAlert(file) {}

  adSearchFilter = {
    groupOp: 'AND',
    rules: [],
  };
  searchAd(event) {
    this.adSearchFilter = event;
    event = Object.assign({}, event);
    this.filter._search = true;
    this.filter.filters = JSON.stringify(event);
    this.filter.page = 1;
    this.getPage(this.filter.page);
  }

  searchRecords(search) {
    if (search === '') {
      this.filter = new AppFilter({ sidx: 'dateCreated' });
      this.getPage(this.filter.page);
    } else {
      let searchFilter = {
        groupOp: 'OR',
        rules: [
          {
            field: 'description',
            op: 'cn',
            data: '',
          },
          {
            field: 'name',
            op: 'cn',
            data: '',
          },
        ],
      };
      searchFilter.rules[0].data = search;
      searchFilter.rules[1].data = search;
      this.filter.filters = JSON.stringify(searchFilter);
      this.getPage(this.currentPage);
    }
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(this.currentPage);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(this.currentPage);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }
}
